import { authService } from './api/auth.service';
import { informeService } from './api/informe.service';
import { ubicacionService } from './api/ubicacion.service';
import { apiClient } from './config/httpClient';

export { authService, informeService, ubicacionService };
export default apiClient;
